import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const API = 'https://crm.ashbournesystems.ca/api';

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem('crm_remembered_email');
    if (saved) { setEmail(saved); setRemember(true); }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { email, password });
      if (remember) {
        localStorage.setItem('crm_remembered_email', email);
      } else {
        localStorage.removeItem('crm_remembered_email');
      }
      toast.success(`Welcome back, ${res.data.name}`);
      onLogin(res.data.token, res.data.role, res.data.name);
    } catch {
      toast.error('Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#0a0500',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      overflow: 'hidden',
      fontFamily: 'Georgia, serif',
    }}>
      {/* Radial glow */}
      <div style={{
        position: 'absolute',
        top: '50%', left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '800px', height: '600px',
        background: 'radial-gradient(ellipse at center, rgba(184,90,34,0.18) 0%, rgba(184,90,34,0.06) 40%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      {/* Grid texture */}
      <div style={{
        position: 'absolute', inset: 0,
        backgroundImage: 'linear-gradient(rgba(184,90,34,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(184,90,34,0.03) 1px, transparent 1px)',
        backgroundSize: '60px 60px',
        pointerEvents: 'none',
      }} />

      <div style={{ position: 'relative', zIndex: 1, width: '100%', maxWidth: '440px', padding: '0 1.5rem' }}>

        {/* Hero header */}
        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <div style={{ fontSize: '0.7rem', color: '#8a6840', letterSpacing: '0.3em', marginBottom: '1rem' }}>
            ◈ CLIENT MANAGEMENT SYSTEM ◈
          </div>
          <div style={{ fontSize: '3rem', fontWeight: 'bold', color: '#F5ECD7', lineHeight: 1, letterSpacing: '-0.02em', marginBottom: '0.25rem' }}>
            ASHBOURNE
          </div>
          <div style={{ fontSize: '3rem', fontWeight: 'bold', color: '#B85A22', lineHeight: 1, letterSpacing: '-0.02em', marginBottom: '1rem' }}>
            SYSTEMS
          </div>
          <div style={{ fontSize: '0.65rem', color: '#8a6840', letterSpacing: '0.25em' }}>
            WEBSITE DEVELOPMENT & CRM INTEGRATION
          </div>
        </div>

        {/* Card */}
        <div style={{
          background: 'rgba(26,15,8,0.95)',
          border: '1px solid #2a1a0e',
          borderTop: '2px solid #B85A22',
          padding: '2rem',
        }}>
          <div style={{ fontSize: '0.65rem', color: '#8a6840', letterSpacing: '0.2em', marginBottom: '1.5rem', textAlign: 'center' }}>
            SIGN IN TO CONTINUE
          </div>

          <form onSubmit={handleLogin}>
            <div style={{ marginBottom: '1rem' }}>
              <label style={{ display: 'block', fontSize: '0.62rem', color: '#8a6840', letterSpacing: '0.15em', marginBottom: '6px' }}>
                EMAIL ADDRESS
              </label>
              <input
                type="email" value={email} onChange={e => setEmail(e.target.value)}
                style={{
                  width: '100%', padding: '0.75rem', background: '#0e0804',
                  border: '1px solid #2a1a0e', color: '#F5ECD7', fontSize: '0.88rem',
                  outline: 'none', boxSizing: 'border-box', fontFamily: 'sans-serif',
                  transition: 'border-color 0.2s',
                }}
                onFocus={e => e.target.style.borderColor = '#B85A22'}
                onBlur={e => e.target.style.borderColor = '#2a1a0e'}
                required
              />
            </div>

            <div style={{ marginBottom: '1.25rem' }}>
              <label style={{ display: 'block', fontSize: '0.62rem', color: '#8a6840', letterSpacing: '0.15em', marginBottom: '6px' }}>
                PASSWORD
              </label>
              <input
                type="password" value={password} onChange={e => setPassword(e.target.value)}
                style={{
                  width: '100%', padding: '0.75rem', background: '#0e0804',
                  border: '1px solid #2a1a0e', color: '#F5ECD7', fontSize: '0.88rem',
                  outline: 'none', boxSizing: 'border-box', fontFamily: 'sans-serif',
                  transition: 'border-color 0.2s',
                }}
                onFocus={e => e.target.style.borderColor = '#B85A22'}
                onBlur={e => e.target.style.borderColor = '#2a1a0e'}
                required
              />
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1.5rem' }}>
              <input
                type="checkbox" id="remember" checked={remember}
                onChange={e => setRemember(e.target.checked)}
                style={{ accentColor: '#B85A22', cursor: 'pointer' }}
              />
              <label htmlFor="remember" style={{ fontSize: '0.72rem', color: '#8a6840', cursor: 'pointer', letterSpacing: '0.05em' }}>
                Remember my email
              </label>
            </div>

            <button type="submit" disabled={loading} style={{
              width: '100%', padding: '0.875rem',
              background: loading ? '#7a3a15' : '#B85A22',
              border: 'none', color: '#F5ECD7', fontSize: '0.75rem',
              letterSpacing: '0.2em', cursor: loading ? 'not-allowed' : 'pointer',
              fontWeight: 'bold', fontFamily: 'Georgia, serif',
              transition: 'background 0.2s',
            }}
            onMouseEnter={e => { if (!loading) e.target.style.background = '#d4682a'; }}
            onMouseLeave={e => { if (!loading) e.target.style.background = '#B85A22'; }}
            >
              {loading ? 'SIGNING IN...' : 'SIGN IN'}
            </button>
          </form>
        </div>

        <div style={{ textAlign: 'center', marginTop: '1.5rem', fontSize: '0.62rem', color: '#4a3020', letterSpacing: '0.1em' }}>
          ASHBOURNE SYSTEMS · STRATFORD, ONTARIO
        </div>
      </div>
    </div>
  );
}